<template>
  <button @click="click" class="app-hashtag" type="button">
    #<slot>hashtag</slot>
  </button>
</template>

<script>
export default {
  name: 'AppHashtag',
  props: {
    route: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
     * Клик по тегу, отправка события родителю
     */
    click() {
      if (this.route) {
        this.$router.push(this.route);
      }
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss">
.app-hashtag {
  @include button-reset;

  padding: 2.5px 6px;
  font-size: rem(10);
  font-weight: 300;
  line-height: 15px;
  color: $color-tag-inactive;
  background-color: $gray-lighter;
  border-radius: 4px;
  transition: color $A;

  &:hover {
    color: $color-tag-active;
  }
}
</style>
